
/** sticky category navigation desktop + mobile */
document.addEventListener("DOMContentLoaded", function () {

function isViewportPastElementID(elementId) {
  // Get the element by ID
  let element = document.getElementById(elementId);
  
  if (!element) {
    console.warn(`Element with ID ${elementId} not found.`);
    return false;
  }

  // Get the bounding rectangle of the element
  let rect = element.getBoundingClientRect();

  // Check if the element is past the viewport
  return (
    rect.top < window.innerHeight && rect.bottom > 500
  );
}


  
  if (document.body.classList.contains("template-page")&&
  document.body.id !== "uber-uns" &&
  document.body.id !== "alle-produkte" &&
    document.body.id !== "dein-30-sekunden-hautpflege-check" &&
    document.body.id !== "adv-tallow-natur" &&
    document.body.id !== "adv-tallow-honig" &&
    document.body.id !== "adv-tallow-lavendel" &&
    document.body.id !== "ihre-schlafgarantie-5-revolutionare-schritte-und-eine-routine-die-ti" &&
  document.body.id !== "haufige-fragen") {
    const wordLimit = 20;
    const mainContentDiv = document.querySelector(".main-content");
    const resultDiv = document.createElement("div");
    resultDiv.classList.add("sticky-page-navigation");
    const ul = document.createElement("ul");
    const li = document.createElement("li");
    li.innerHTML = "<strong>DIREKT ZU</strong>";
    ul.appendChild(li);

    const filterLinkMobileAnchor = document.createElement("div");
    filterLinkMobileAnchor.classList.add("ntn-cat-filter-link-anchor");

    const filterLinkMobile = document.createElement("div");
    filterLinkMobile.classList.add("ntn-cat-filter-link");
    filterLinkMobile.innerHTML = '<a href="#"> <svg style="padding-top:5px;" width="26px" height="26px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" id="Editable-line" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="  M3.241,7.646L13,19v9l6-4v-5l9.759-11.354C29.315,6.996,28.848,6,27.986,6H4.014C3.152,6,2.685,6.996,3.241,7.646z" fill="none" id="XMLID_6_" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></path></svg> FILTER: <span style="font-weight:100">DIREKT ZU</span> </a>';

    const resultDivMobile = document.createElement("div");
    resultDivMobile.classList.add("sticky-page-navigation-overlay");
    resultDivMobile.id = "sticky-page-navigation-overlay";

    const resultDivMobileContent = document.createElement("div");
    resultDivMobileContent.classList.add("content");
    resultDivMobile.appendChild(resultDivMobileContent);

    const closeButtonMobile = document.createElement("span");
    closeButtonMobile.classList.add("close-page-navigation-overlay");
    closeButtonMobile.classList.add("close-icon");
    closeButtonMobile.innerHTML = "✖";
    resultDivMobileContent.appendChild(closeButtonMobile);

    if (mainContentDiv) {
      mainContentDiv.prepend(filterLinkMobile);
      mainContentDiv.prepend(filterLinkMobileAnchor);
      const featuredProductDivs = mainContentDiv.querySelectorAll(
        ".shopify-section.featured-products-wrapper"
      );

 

      featuredProductDivs.forEach(function (div) {
        const divId = div.getAttribute("id");
        const sectionWrapper = div.querySelector(".section-title--wrapper");

        if (sectionWrapper) {
          const sectionTitle = sectionWrapper.querySelector("h2");
          if (sectionTitle) {
            const li = document.createElement("li");
            li.innerHTML =
              '<a class="custom-sticky-bullets" id="nav-anchor-'+divId+'" href="#' + divId + '">' + sectionTitle.textContent + "</a>";
            ul.appendChild(li);
           
          }

          if (window.innerWidth < 990) {
            const sectionDescription = sectionWrapper.querySelector(
              ".section-description p"
            );
            if (sectionDescription) {
              const fullText = sectionDescription.textContent;
              const wordCount = fullText.split(" ");

              if (wordCount.length > wordLimit) {
                const truncatedText =
                  wordCount.slice(0, wordLimit).join(" ") + "...";
                console.log(truncatedText);
                sectionDescription.innerHTML =
                  '<p id="' + divId + '-shorttext">' + truncatedText + "</p>";

                sectionDescription.insertAdjacentHTML(
                  "afterend",
                  '<p style="display:none;" id="' +
                    divId +
                    '-fulltext">' +
                    fullText +
                    "</p>"
                );
                sectionDescription.insertAdjacentHTML(
                  "afterend",
                  '<a data-id="' +
                    divId +
                    '" id="' +
                    divId +
                    '-button" href="#">Mehr anzeigen</a>'
                );

                const openButon = document.getElementById(divId + "-button");
                openButon.addEventListener("click", function (event) {
                  event.preventDefault();
                  const id = this.getAttribute("data-id");
                  document.getElementById(id + "-shorttext").style.display =
                    "none";
                  document.getElementById(id + "-fulltext").style.display =
                    "block";
                  this.style.display = "none";
                });
              }
            }
          }
        }


      
      });




  function checkLeftMenuAnchorVisibility() {
         featuredProductDivs.forEach(function (div) {
         const divId = div.getAttribute("id");
        
            if (isViewportPastElementID(divId)) {
                      document.getElementById('nav-anchor-'+divId+'').classList.add("active"); 
                    } else {
                      document.getElementById('nav-anchor-'+divId+'').classList.remove("active");
                    }
              });
  }
  window.addEventListener("scroll", checkLeftMenuAnchorVisibility);
  window.addEventListener("resize", checkLeftMenuAnchorVisibility);
 


      
      var clonedUl = ul.cloneNode(true);
      ul.classList.add("ntn-cat-nav");
      clonedUl.classList.add("ntn-cat-nav-mobile");
      resultDiv.appendChild(ul);
      resultDivMobileContent.appendChild(clonedUl);
      mainContentDiv.parentNode.insertBefore(resultDiv, mainContentDiv);
      mainContentDiv.parentNode.insertBefore(resultDivMobile, mainContentDiv);

      closeButtonMobile.addEventListener("click", function (event) {
        document
          .getElementById("sticky-page-navigation-overlay")
          .classList.remove("show");
        document.body.classList.remove("overlay-active");
      });

      filterLinkMobile.addEventListener("click", function (event) {
        event.preventDefault();
        document
          .getElementById("sticky-page-navigation-overlay")
          .classList.add("show");
        document.body.classList.add("overlay-active");

        var links = document.querySelectorAll(
          "#sticky-page-navigation-overlay a"
        );

        links.forEach(function (link) {
          link.addEventListener("click", function (event) {
            document
              .getElementById("sticky-page-navigation-overlay")
              .classList.remove("show");
            document.body.classList.remove("overlay-active");
          });
        });

        document.addEventListener("keydown", function (event) {
          if (event.key === "Escape") {
            document
              .getElementById("sticky-page-navigation-overlay")
              .classList.remove("show");
            document.body.classList.remove("overlay-active");
          }
        });
        //document.getElementById("overlayBackground").classList.add("show");
      });

      function checkButtonVisibility() {
        const filterButtonMobile = document.querySelector(
          ".ntn-cat-filter-link"
        );
        const filterButtonMobileAnchor = document.querySelector(
          ".ntn-cat-filter-link-anchor"
        );
        if (filterButtonMobileAnchor && window.innerWidth < 769) {
          if (!isInViewport(filterButtonMobileAnchor)) {
            filterButtonMobile.classList.add("fixed");
          } else {
            filterButtonMobile.classList.remove("fixed");
          }
        }
      }

      window.addEventListener("scroll", checkButtonVisibility);
      window.addEventListener("resize", checkButtonVisibility);

      checkButtonVisibility();
    }
  }
});

function isInViewport(element) {
  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function isViewportPastElement(element) {
  const rect = element.getBoundingClientRect();

  return rect.bottom < 60;
}
 
function isViewportPastElementID(elementId) {
  // Get the element by ID
  let element = document.getElementById(elementId);
  
  if (!element) {
    console.warn(`Element with ID ${elementId} not found.`);
    return false;
  }

  // Get the bounding rectangle of the element
  let rect = element.getBoundingClientRect();

  // Check if the element is past the viewport
  return (
    rect.top < window.innerHeight && rect.bottom > 500
  );
}

 

/** sticky cart button */
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(
    ".product--add-to-cart-button"
  );
  const paymentButtons = document.querySelector(".paymentButtonsWrapper");

  const newDiv = document.createElement('div');
newDiv.id = 'custom-space'; // Set the id
newDiv.style.height = '46px'; // Set the height style

  
  function checkButtonVisibility() {
    if (addToCartButton && !addToCartButton.disabled && window.innerWidth < 768) {
      if (!isInViewport(paymentButtons)&& window.scrollY > 150) {
        addToCartButton.classList.add("fixed-add-to-cart");
        addToCartButton.parentNode.insertBefore(newDiv, addToCartButton);  
      } else {
        addToCartButton.classList.remove("fixed-add-to-cart");
         newDiv.remove();
      }
    }
  }

  window.addEventListener("scroll", checkButtonVisibility);
  window.addEventListener("resize", checkButtonVisibility);

  checkButtonVisibility();
});


function isScrollPositionHigher(divId) {
  // Get the div element by its id
  const divElement = document.getElementById(divId);

  // Check if the div element exists
  if (divElement) {
    // Get the current scroll position of the page
    const scrollPosition = window.scrollY || window.pageYOffset;

    // Get the position of the div relative to the top of the page
    const divPosition = divElement.getBoundingClientRect().top + window.scrollY;

    // Check if the scroll position is higher than the div's position
    return scrollPosition > divPosition;
  }
  return false; // Return false if the div doesn't exist
}


function scrollToCorrectElementById(elementId) {
  // Select the LI element by its id
  const targetItem = document.getElementById(elementId);

  // Check if the element exists
  if (targetItem  && window.innerWidth < 768 && isScrollPositionHigher('inhaltsstoffe')) {
    // Scroll the LI element into view
    targetItem.scrollIntoView({ behavior: 'smooth', inline: 'end' });
  }
}



/** sticky product nav */
document.addEventListener("DOMContentLoaded", function () {
  const productNav = document.querySelector(".ntn-product-nav");
  const productNavMarker = document.querySelector(".ntn-product-nav-marker");

    const inhaltsstoffe = document.getElementById("inhaltsstoffe");
    const inhaltsstoffeAnchor = document.getElementById("nav-inhaltsstoffe");
    const wirkung = document.getElementById("wirkung");
    const wirkungAnchor = document.getElementById("nav-wirkung");
    const dosierung = document.getElementById("dosierung");
    const dosierungAnchor = document.getElementById("nav-dosierung");
    const details = document.getElementById("details");
    const detailsAnchor = document.getElementById("nav-details");
    const bewertungen = document.getElementById("bewertungen");
    const bewertungenAnchor = document.getElementById("nav-bewertungen");
    const wirkstoffe = document.getElementById("wirkstoffe");
    const wirkstoffeAnchor = document.getElementById("nav-wirkstoffe");
    const qualitaet = document.getElementById("qualitaet");
    const qualitaetAnchor = document.getElementById("nav-qualitaet");
    const labortests = document.getElementById("labortests");
    const labortestsAnchor = document.getElementById("nav-labortests");

  const newDiv2 = document.createElement('div');
newDiv2.id = 'custom-space'; // Set the id
newDiv2.style.height = '46px'; // Set the height style


  
  function checkButtonVisibility() {
    if (productNav) {
      if (isViewportPastElement(productNavMarker)) {
        productNav.classList.add("fixed-product-nav");
        productNav.parentNode.insertBefore(newDiv2, productNav);  
      } else {
        productNav.classList.remove("fixed-product-nav");
        newDiv2.remove();

      }
    }
  }
  
  function checkButtonActivity() { 

    if(inhaltsstoffe){
      if (isViewportPastElementID('inhaltsstoffe')) {
        inhaltsstoffeAnchor.classList.add("active"); 
                scrollToCorrectElementById('nav-inhaltsstoffe');
        console.log('inhalt');
      } else {
        inhaltsstoffeAnchor.classList.remove("active");
      }
    }
    if(wirkung){
      if (isViewportPastElementID('wirkung')) {
        wirkungAnchor.classList.add("active"); 
                scrollToCorrectElementById('nav-wirkung');
        console.log('wirkung');
      } else {
        wirkungAnchor.classList.remove("active");
      }
    }
    if(dosierung){
      if (isViewportPastElementID('dosierung')) {
        dosierungAnchor.classList.add("active"); 
                scrollToCorrectElementById('nav-dosierung');

      } else {
        dosierungAnchor.classList.remove("active");
      }
    }
    if(details){
      if (isViewportPastElementID('details')) {
        detailsAnchor.classList.add("active");
                scrollToCorrectElementById('nav-details');
      } else {
        detailsAnchor.classList.remove("active");
      }
    }
    if(bewertungen){
      if (isViewportPastElementID('bewertungen')) {
        bewertungenAnchor.classList.add("active");
                scrollToCorrectElementById('nav-bewertungen');
      } else {
        bewertungenAnchor.classList.remove("active");
      }
    } 
    if(wirkstoffe){
      if (isViewportPastElementID('wirkstoffe')) {
        wirkstoffeAnchor.classList.add("active");
        scrollToCorrectElementById('nav-wirkstoffe');
      } else {
        wirkstoffeAnchor.classList.remove("active");
      }
    }
    if(qualitaet){
      if (isViewportPastElementID('qualitaet')) {
        qualitaetAnchor.classList.add("active");
        scrollToCorrectElementById('nav-qualitaet');
      } else {
        qualitaetAnchor.classList.remove("active");
      }
    }
    if(labortests){
      if (isViewportPastElementID('labortests')) {
        labortestsAnchor.classList.add("active");
        scrollToCorrectElementById('nav-labortests');
      } else {
        labortestsAnchor.classList.remove("active");
      }
    }
  }

  window.addEventListener("scroll", checkButtonVisibility);
  window.addEventListener("resize", checkButtonVisibility);
  window.addEventListener("scroll", checkButtonActivity);
  window.addEventListener("resize", checkButtonActivity);

  checkButtonVisibility();
  checkButtonActivity();
});

/** search overlay */
document.addEventListener("DOMContentLoaded", function () {
  var overlay = document.getElementById("search-overlay");
  var openLink = document.querySelector(".ntn-search-button");
  var openLinkMobile = document.querySelector(".ntn-search-button-mobile");
  var closeButton = document.querySelector(".close-search-overlay");

  function openSearchOverlay() {
    overlay.style.display = "block";
  }

  function closeSearchOverlay() {
    overlay.style.display = "none";
  }

  openLink.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default anchor behavior
    openSearchOverlay();
  });

  openLinkMobile.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default anchor behavior
    openSearchOverlay();
  });

  closeButton.addEventListener("click", function () {
    closeSearchOverlay();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Check if the pressed key is Escape
      closeSearchOverlay();
    }
  });
});

/** preicitve search - search suggestions */
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("ntn-predictive-search-input");

  searchInput.addEventListener("input", function () {
    const query = searchInput.value;

    if (query.length > 2) {
      // Only send requests for queries longer than 2 characters
      sendSearchRequest(query);
    }
  });

  function sendSearchRequest(query) {
    fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        query
      )}&resources[type]=page,product&resources[options][fields]=body,tag,title&prefix=last`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        displaySuggestions(data.resources.results);
      })
      .catch((error) => {});
  }

  function displaySuggestions(results) {
    const suggestionsWrapper = document.querySelector(
      ".ntn-suggestions-wrapper"
    );
    const suggestionsContainer = document.getElementById("ntn-suggestions");
    suggestionsContainer.innerHTML = "";
    suggestionsWrapper.style.display = "block";

    if (results.products && results.products.length > 0) {
      const titleItemProducts = document.createElement("div");
      titleItemProducts.innerHTML = `<h6>Produkte</h6>`;
      suggestionsContainer.appendChild(titleItemProducts);

      results.products.forEach((product) => {
        const suggestionItem = document.createElement("span");
        suggestionItem.classList.add("suggestion-item");
        suggestionItem.innerHTML = `<a href="${product.url}">${product.title}</a><br>`;
        titleItemProducts.appendChild(suggestionItem);
      });
    }

    if (results.pages && results.pages.length > 0) {
      var pagesExist = false;
      var gutFuerPagesExist = false;

      //check what pages we have
      results.pages.forEach((page) => {
        if (page.title.startsWith("Gut für")) {
          gutFuerPagesExist = true;
        } else {
          pagesExist = true;
        }
      });

      const titleItem = document.createElement("div");
        titleItem.innerHTML = `<h6>Kategorien</h6>`;
      const titleItemGutFuer = document.createElement("div");
        titleItemGutFuer.innerHTML = `<h6>Gut für</h6>`;

      if (pagesExist === true) {
        suggestionsContainer.appendChild(titleItem);
      }

      if (gutFuerPagesExist === true) {
        suggestionsContainer.appendChild(titleItemGutFuer);
      }

      results.pages.forEach((page) => {
        const suggestionItem = document.createElement("span");
        const pageUrl = page.url;
        suggestionItem.classList.add("suggestion-item");

        if (page.title.startsWith("Gut für")) {
          const pageTitle = page.title.replace(
            new RegExp("Gut für > ", "g"),
            ""
          );

          if (pageTitle !== "" && pageTitle !== "Gut für") {
            suggestionItem.innerHTML = `<a href="${page.url}">${pageTitle}</a><br>`;
            titleItemGutFuer.appendChild(suggestionItem);
          }
        } else {
          suggestionItem.innerHTML = `<a href="${page.url}">${page.title}</a><br>`;
          titleItem.appendChild(suggestionItem);
        }

        suggestionItem.addEventListener("click", function (event) {
          event.preventDefault();

          fetch(pageUrl)
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const mainContentDiv = doc.querySelector(".main-content");

              if (mainContentDiv) {
                contentContainer.style.display = "block";
                contentContainer.innerHTML = mainContentDiv.innerHTML;
                window.history.pushState({}, "", pageUrl);
              }
            })
            .catch((error) => {});
        });
      });

      const contentContainer = document.getElementById(
        "ntn-predictive-content"
      );

      const url = results.pages[0]["url"];
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const mainContentDiv = doc.querySelector(".main-content");

          if (mainContentDiv) {
            contentContainer.style.display = "block";
            contentContainer.innerHTML = mainContentDiv.innerHTML;
            window.history.pushState({}, "", url);
          }
        })
        .catch((error) => {});
    }
  }
});

/** Collapse product description if too long */
document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector(
    ".product-details-wrapper .product-description"
  );
  var content = document.querySelector(
    ".product-details-wrapper .product-description .text-link-animated"
  );

  if (container && content) {
    if (content.scrollHeight > container.clientHeight) {
      var toggleButton = document.createElement("button");
      toggleButton.textContent = `Mehr zeigen`;
      toggleButton.classList.add("ntn-product-description-toggle-button");

      container.insertAdjacentElement("afterend", toggleButton);

      toggleButton.addEventListener("click", function () {
        container.classList.toggle("expanded");

        if (container.classList.contains("expanded")) {
          toggleButton.textContent = "Weniger zeigen";
          toggleButton.classList.add("open");
        } else {
          toggleButton.textContent = "Mehr zeigen";
          toggleButton.classList.remove("open");
        }
      });
    }
  }
});



  document.addEventListener("DOMContentLoaded", function () {

    const offset = 250;

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
          });
        }
      });
    });

  });

